import './index.scss'
var oTable = $('table');
if (oTable.length !== 0) {
    var oTr = oTable.find('tr'),
        oTd = oTable.find('td');

    oTable.wrap("<div class='table-box'></div>");
    oTr.attr('style', '');
    if (oTable.find("td[style='text-align: center']").length !== 0) {
        oTd.attr('style', '');
        oTd.css({
            'text-align': 'center',
        });
    } else {
        oTd.attr('style', '');
    }
}

$(".product-nav dt").click(function(){

    let $dl = $(this).parent();

    if($dl.hasClass("active")){

        $dl.removeClass("active");

    }else{

        $(".product-nav dl").removeClass("active");

        $dl.addClass("active");
    }

});